// extracted by mini-css-extract-plugin
export default {"innerText":"IxkfWw7sBKkQ94bUdTbQ","innerTextLoading":"rEKu8pf_qLJgbQAc4r14","loader":"YsbHzhBkIpEHZInej3ZG","loaderVisible":"fFCtJYP3LNiuSY4GC6MI"};